import { render } from "./LogoEducation.vue?vue&type=template&id=694e2078&scoped=true"
const script = {}

import "./LogoEducation.vue?vue&type=style&index=0&id=694e2078&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694e2078"]])

export default __exports__